'use strict';

var React = require('react');

var SvgPersonLockFilledIcon = function SvgPersonLockFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 6.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Zm8.251 10.5h-.751a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h3.5v-1.75a.75.75 0 0 0-1.5 0 .75.75 0 0 1-1.5 0 2.25 2.25 0 0 1 4.5 0v1.75a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-4.249Zm-2.146-5.434a1.994 1.994 0 0 0-.605 1.434v3c0 .364.097.706.268 1h-.854a.756.756 0 0 1-.1.007h-5.93c-.408 0-.805-.167-1.074-.478a1.263 1.263 0 0 1-.24-1.243c.322-.96 1.094-2.246 2.361-3.157a5.82 5.82 0 0 1 2.762-1.067 5.42 5.42 0 0 1 .807-.062c.915 0 1.8.2 2.605.566Z"
  }));
};
SvgPersonLockFilledIcon.displayName = "PersonLockFilledIcon";

exports.SvgPersonLockFilledIcon = SvgPersonLockFilledIcon;
